var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 11h14v2H5v-2z"}));
}

Minus.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Minus;

Minus.default = Minus;
